var map = {
	"./partners1.svg": "c06d",
	"./partners10.svg": "469e",
	"./partners11.svg": "4cbc",
	"./partners12.svg": "c4e3",
	"./partners13.svg": "b554",
	"./partners14.svg": "2f6e",
	"./partners15.svg": "c65f",
	"./partners16.svg": "aa4d",
	"./partners17.svg": "f129",
	"./partners18.svg": "8ebf",
	"./partners19.svg": "7ad8",
	"./partners2.svg": "4085",
	"./partners20.svg": "2b6e",
	"./partners21.svg": "26f7",
	"./partners22.svg": "3ffe",
	"./partners23.svg": "4ea4",
	"./partners24.svg": "e2e4",
	"./partners25.svg": "266c",
	"./partners26.svg": "591a",
	"./partners27.svg": "c482",
	"./partners28.svg": "a933",
	"./partners29.svg": "a0ee",
	"./partners3.svg": "3a21",
	"./partners30.svg": "d2f7",
	"./partners31.svg": "991b",
	"./partners32.svg": "0d0c",
	"./partners33.svg": "cec8",
	"./partners34.svg": "ae72",
	"./partners35.svg": "b4fc",
	"./partners36.svg": "d232",
	"./partners37.svg": "0758",
	"./partners38.svg": "fb9a",
	"./partners39.svg": "db63",
	"./partners4.svg": "1368",
	"./partners40.svg": "7fba",
	"./partners41.svg": "8989",
	"./partners42.svg": "7683",
	"./partners43.svg": "3214",
	"./partners44.svg": "a56a",
	"./partners45.svg": "4fae",
	"./partners46.svg": "f3c6",
	"./partners5.svg": "2b61",
	"./partners6.svg": "41df",
	"./partners7.svg": "1e84",
	"./partners8.svg": "7097",
	"./partners9.svg": "d6d7",
	"./partners_left.svg": "c87a",
	"./partners_right.svg": "dc4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0abd";